import { Box, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import API from '../../api/api'
import { loginViaMagicLinkMutation } from '../../api/mutations/userMutations'
import ErrorMessage from '../../components/UI/ErrorMessage'
import { useErrorState } from '../../hooks/useErrorState'
import Loader from '../../components/UI/Loader'
import { SUPPLIERS_ROLES } from '../../utils/constants'

export default function MagicLinkTarget(props) {
  const [isResponseOk, setIsResponseOk] = useState(false)
  const { error, setErrorState } = useErrorState()
  const history = useHistory()
  const { token } = props.match.params

  const loginViaMagicLink = async () => {
    try {
      const userResult = await API.queryAPI(loginViaMagicLinkMutation(token))

      if (!SUPPLIERS_ROLES.includes(userResult.loginViaMagicLink.role)) {
        throw 'Vous n’avez pas les droits pour accéder à cette page.'
      }

      setIsResponseOk(true)
      localStorage.setItem('user', JSON.stringify(userResult.loginViaMagicLink))

      setTimeout(() => {
        history.replace('/')
      }, 1000)
    } catch (errorMessage) {
      setErrorState(errorMessage)
    }
  }

  useEffect(() => {
    loginViaMagicLink()
  }, [])

  return (
    <>
      {(isResponseOk && (
        <>
          <Box mb={2}>
            <Typography variant="h4">
              <Loader />
              <span style={{ margin: '5px' }}>Redirection</span>
            </Typography>
          </Box>
          <Box color="green" mb={2}>
            Votre authentification à réussi, nous allons vous rediriger vers le dashboard.
          </Box>
        </>
      )) || (
        <>
          <Box mb={2}>
            <Typography variant="h4">
              <Loader />
              <span style={{ margin: '5px' }}>En attente de l’authentification</span>
            </Typography>
          </Box>
          <Box mb={2} variant="subtitle1">
            Nous attendons la confirmation de l’authentification sécurisée.
          </Box>
        </>
      )}
      <ErrorMessage error={error} />
    </>
  )
}
